// @ts-nocheck
import { KanbanState, KanbanActions, KanbanAction } from '../../types/kanban';

const initialState: KanbanState = {
  routes: null,
  loading: false,
  error: null,
};

export const kanbanReducer = (state = initialState, action: KanbanAction): KanbanState => {
  switch (action.type) {
    case KanbanActions.FETCH_KANBAN_ROUTES:
      return { ...state, loading: true, error: null, routes: null };
    case KanbanActions.FETCH_KANBAN_ROUTES_SUCCESS:
      return { ...state, loading: false, error: null, routes: action.payload };
    case KanbanActions.FETCH_KANBAN_ROUTES_ERROR:
      return { ...state, loading: false, error: action.payload, routes: null };
    default:
      return state;
  }
};
